import { createAction } from "redux-act";

export const REQSrchRecList = createAction("REQUEST_SRHREC_LIST");
export const RESSrchRecList = createAction("RECEIVE_SRHREC_LIST");
export const FailSrchRecList = createAction("FAILED_SRHREC_LIST");
export const CleanUpSrchRecList = createAction("CLEANUP_SRHREC_LIST");